import { Owner, OwnerType } from "@/api/SolarCloudApi";
import { cn } from "@/util/cn";
import {
  findDefaultAddress,
  findDefaultPhoneNumber,
} from "@/util/user";

interface OwnerDetailsProps {
  owner?: Owner;
  className?: string;
}

function formatABN(abn?: string): string {
  if (!abn) return "";
  const digitsOnly = abn.replace(/\D/g, "");
  return digitsOnly.replace(/^(\d{2})(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3 $4");
}

export default function OwnerDetails({ owner, className }: OwnerDetailsProps) {
  if (!owner) {
    return <div className="text-gray-500">No owner information available</div>;
  }

  if (owner.type === OwnerType.USER && owner.user) {
    const user = owner.user;
    const phoneNumber = findDefaultPhoneNumber(user);
    const address = findDefaultAddress(user);
    const hasAddress = Boolean(
      address &&
        (address.line1 || address.line2 || address.city || address.state ||
          address.postcode || address.country)
    );

    return (
      <div className={cn("space-y-2", className)}>
        {/* <div className="text-lg">
          {user.givenName} {user.familyName}
        </div>
        {phoneNumber && <div className="">{phoneNumber}</div>}
        {address && (
          <div className="">
            <div>{address.line1}</div>
            {address.line2 && <div>{address.line2}</div>}
            <div>
              {address.city} {address.state} {address.postcode}
            </div>
            {address.country && <div>{address.country}</div>}
          </div>
        )} */}
        <div className="grid grid-cols-4 gap-4">
          <div className="grid-cols-1 text-sm text-muted-foreground">Name</div>
          <div className="col-span-3">
            {user.givenName} {user.familyName}
          </div>
          {phoneNumber?.number && (
            <>
              <div className="grid-cols-1 text-sm text-muted-foreground">
                Phone
              </div>
              <div className="col-span-3">{phoneNumber?.number}</div>
            </>
          )}
          {hasAddress && (
            <>
              <div className="grid-cols-1 text-sm text-muted-foreground">
                Address
              </div>
              <div className="col-span-3">
                <div>{address!.line1}</div>
                {address!.line2 && <div>{address!.line2}</div>}
                <div>
                  {address!.city} {address!.state} {address!.postcode}
                </div>
                {address!.country && <div>{address!.country}</div>}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  if (owner.type === OwnerType.ORGANISATION && owner.organisation) {
    const organisation = owner.organisation;
    const phoneNumber = findDefaultPhoneNumber(organisation);
    const address = findDefaultAddress(organisation);

    return (
      <div className="space-y-2">
        <div className="text-lg font-semibold">{organisation.name}</div>
        {organisation.abn && (
          <div className="">ABN: {formatABN(organisation.abn)}</div>
        )}
        {phoneNumber?.number && <div className="">Phone: {phoneNumber.number}</div>}
        {address && (
          <div className="">
            <div>Address:</div>
            <div className="ml-4">
              <div>{address.line1}</div>
              {address.line2 && <div>{address.line2}</div>}
              <div>
                {address.city} {address.state} {address.postcode}
              </div>
              {address.country && <div>{address.country}</div>}
            </div>
          </div>
        )}
      </div>
    );
  }

  return <div className="">Invalid owner type</div>;
}
